<script setup lang="ts">
defineProps<{
  currency: string
  amount: number
  billingFrequency: string
}>();
</script>

<template>
  <div class="w-full flex flex-col items-center justify-center h-[49px]">
    <div class="flex text-primary-600 dark:text-primary-400">
      <div class="font-bold text-sm mt-[5px] leading-[16px]!">
        {{ currency }}
      </div>
      <div class="text-[30px] leading-[35px]! font-bold mx-2">
        {{ Math.round(amount / 100) }}
      </div>
    </div>
    <div class="text-gray-400 text-[12px] leading-[14px]!">
      {{ billingFrequency }}
    </div>
  </div>
</template>
